export type BusinessDayConfig = {
  timeZone: string;
  startMinutes: number;
};

const DEFAULT_BUSINESS_DAY: BusinessDayConfig = {
  timeZone: "Europe/London",
  startMinutes: 240,
};

export function businessDateFor(occurredAt: string, config: BusinessDayConfig = DEFAULT_BUSINESS_DAY): string {
  if (!Number.isInteger(config.startMinutes) || config.startMinutes < 0 || config.startMinutes > 1439) {
    throw new Error("Business day start must be between 00:00 and 23:59");
  }
  const date = new Date(occurredAt);
  if (Number.isNaN(date.getTime())) throw new Error("Invalid occurredAt");
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: config.timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const minutes = Number(values.hour) * 60 + Number(values.minute);
  const utcDate = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
  if (minutes < config.startMinutes) utcDate.setUTCDate(utcDate.getUTCDate() - 1);
  return utcDate.toISOString().slice(0, 10);
}

export const DEFAULT_BUSINESS_DAY_CONFIG = DEFAULT_BUSINESS_DAY;
